module.exports = __webpack_public_path__ + "static/media/3DPPA25.e6da6e79.jpg";